import styled from "styled-components";
import { Summary } from "./SummaryControl/Summary";

export function SummaryView() {
  return (
    <Container>
      <Summary />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;
